<script lang="ts">
	import { onMount, onDestroy } from "svelte";
	import { isUpdatingSerpData, isFiltersUpdating, totalItemsStores } from "../../stores/stores.filters";
	import Filters from "../filters/Filters.svelte";
	import UsedFilters from "../usedFilters/UsedFilters.svelte";
	import Paginations from "../paginations/Paginations.svelte";
	import Orders from "../orders/Orders.svelte";
	import ProductList from "../productList/ProductList.svelte";
	import { Loader } from "../../../generic/components";
	import { TypeModule } from "../../../types/types.serpPage";
	import { Unsubscriber } from "svelte/store";
	import { mediaQuery } from "../../../generic/scripts/mediaquery.store";

	export let type: TypeModule;
	export let itemList: string;
	export let categoryList: string;
	export let itemListName: string;
	export let itemListId: string;

	let totalItems: number = 0;

	onMount(() => {
		if (type == "Category") {
			EC.notifier.events.ItemListReload.notify();
		}
	});

	const totalItemsStoresUnsubscribe = totalItemsStores.subscribe((val) => {
		totalItems = val;
	});

	const isFiltersUpdatingUnsubscribe: Unsubscriber = isFiltersUpdating.subscribe((isUpdate) => {
		if (isUpdate) {
			itemList = "";
		}
	});

	onDestroy(() => {
		isFiltersUpdatingUnsubscribe();
		totalItemsStoresUnsubscribe();
	});
</script>

<svelte:window on:resize={mediaQuery.updateBreakpoint} />

<div class="position-relative">
	{#if $isUpdatingSerpData}
		<Loader outDelay={200} />
	{/if}
	<div class="serpGrid">
		<div class="serpFilters position-relative d-flex flex-column gap-3">
			{#if type == "Category"}
				<div class="sidebarWrapper">
					{@html categoryList}
				</div>
			{/if}
			<Filters />
		</div>
		<div class="serpTopBar d-flex flex-column gap-3">
			{#if totalItems > 0}
				<UsedFilters />
				{#if type != "ProductFinder"}
					<div class="d-flex justify-content-between gap-3">
						<Orders />
						<Paginations />
					</div>
				{/if}
			{/if}
		</div>
		<div class="serpProductList position-relative">
			<ProductList {itemListName} {itemListId} />
			{#if type == "Category"}
				{@html itemList}
			{/if}
		</div>
		{#if type != "ProductFinder"}
			<div class="serpBottomBar">
				{#if totalItems > 0}
					<Paginations />
				{/if}
			</div>
		{/if}
	</div>
</div>
